module.exports = __webpack_public_path__ + "img/imacena.15df9108.png";